module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Flower#3-ab53bf197d4d8b1047935af5eb186512.svg";